import React from 'react';
import Subcategory from '../modules/models/subcategory';
import SubcategoryComponent from './subcategory';
import classNames from "classnames";

const Category = ({ category }: any) => {
  let hasVisibleContent = category.content.filter((el: Subcategory) => el.table.length).length > 0
  return (
    <div className={classNames("rounded-xl dark:text-gray-400 border border-gray-100 dark:border-gray-700 dark:hover:border-gray-600 hover:shadow-lg dark:hover:shadow-lg-light bg-white dark:bg-gray-900 mb-4 sm:mx-2 overflow-hidden", {
      "opacity-50 bg-gray-60 cursor-not-allowed hover:shadow-none dark:hover:shadow-none": !hasVisibleContent,
    })}>
      <h2 className={classNames("bg-gray-50 dark:bg-gray-700 rounded-t-lg py-2.5 px-3 flex justify-between items-center border-b border-gray-200 dark:border-gray-700", {
        "opacity-50 bg-gray-60 cursor-not-allowed": !hasVisibleContent,
        "text-opacity-20": !hasVisibleContent
      })}>{category.title}</h2>
      {
        category.content.map((subcategory: Subcategory, index: Number) => {
          return subcategory.table.length > 0 && <SubcategoryComponent key={'Subcat-' + index} subcategory={subcategory} />;
        })
      }
    </div>
  )
};

export default Category;
